import { Input } from '@mairistem/composants';
import { ListeTable } from '@mairistem/liste';
import React from 'react';
import type { Etiquette } from '@/src/interfaces/etiquette';

interface EtiquetteRowProps {
	etiquette: Etiquette;
	rowProps: any;
	utilities: any;
}

const EtiquetteRow = ({
	etiquette,
	rowProps,
	utilities,
}: EtiquetteRowProps) => {
	const handleChange = (_e, { name, value }) => {
		utilities?.onChange({ [name]: value });
	};

	return (
		<ListeTable.Row key={etiquette?.identifiant} {...rowProps}>
			<ListeTable.Cell name="libelle" stretched>
				<Input
					name="libelle"
					value={etiquette?.libelle}
					onChange={handleChange}
					fluid
					transparent
					autoFocus={utilities?.autoFocus}
				>
					<input data-testid={`etiquetteListeRow-${etiquette?.identifiant}`} />
				</Input>
			</ListeTable.Cell>
		</ListeTable.Row>
	);
};

export default EtiquetteRow;
